var styles = {"badge":"Badge-module_badge__dq1Zm","sm":"Badge-module_sm__1VZ8W","lg":"Badge-module_lg__1vCFV"};

export { styles as default };
//# sourceMappingURL=Badge.module.css.js.map
